import React from "react";
import { Modal, Typography, Table, Card, Row, Col,Image } from "antd";

const { Title, Text } = Typography;

const OrderDetailsModal = ({ visible, order, staffData, onCancel }) => {
  const [modalWidth, setModalWidth] = React.useState(1200); // Adjust modal width as needed

  const columns = [
    {
      title: "Item",
      dataIndex: "product_name",
      key: "product_name",
    },
    {
      title: "Quantity",
      dataIndex: "product_quantity",
      key: "product_quantity",
    },
    {
      title: "Price",
      dataIndex: "product_price",
      key: "product_price",
      render: (text) => `${text}`,
    },
    {
      title: "Image",
      dataIndex: "product_image",
      key: "product_image",
      render: (text) => <Image src={text} alt="Product" style={{ width: 100 }} />,
    },
  ];

  return (
    <Modal
      title=""
      visible={visible}
      onCancel={onCancel}
      width={modalWidth}
      footer={null} // No footer buttons
    >
      <Row gutter={[16, 16]}>
        {/* Order Information Card */}
        <Col span={24}>
          <Card title="Order Information" bordered={false}>
            <Title level={5}>Order ID</Title>
            <Text strong>{order?.order_id}</Text>

            <Title level={5} style={{ marginTop: 16 }}>
              Order Date
            </Title>
            <Text>
              {order ? new Date(order.order_date).toLocaleString() : ""}
            </Text>

            <Title level={5} style={{ marginTop: 16 }}>
              Billing Address
            </Title>
            <Text>{order?.billing.address}</Text>
          </Card>
        </Col>

        {/* Order Items Card */}
        <Col span={24}>
          <Card title="Order Items" bordered={false}>
            <Table
              columns={columns}
              dataSource={order?.items}
              rowKey="product_id"
            />
          </Card>
        </Col>
      </Row>
    </Modal>
  );
};

export default OrderDetailsModal;
